import { Card, Group, Stack } from "@mantine/core";

import { IconAlertTriangle, IconX } from "@tabler/icons-react";

import { TextWrapper } from "../TextWrapper";

import { GA_ALERT_SUBTITLE, GA_ALERT_TITLE } from "./constants";

interface GAAlertMessageCardProps {
  onClose?: () => void;
  iconX?: boolean;
}

const GAAlertMessageCard = ({ onClose = () => {}, iconX = true }: GAAlertMessageCardProps) => {
  return (
    <Card radius="md" data-testid="ga-overdue-alert" bd="1px solid var(--mantine-color-orange-6)">
      <Card.Section p="xs">
        <Group gap="xs" wrap="nowrap" align="flex-start">
          <IconAlertTriangle size={20} color="var(--mantine-color-orange-6)" />
          <Stack gap="xs" style={{ width: "100%" }}>
            <TextWrapper
              fz="sm"
              c="orange.8"
              variant="bold"
              display="flex"
              style={{ justifyContent: "space-between" }}
            >
              {GA_ALERT_TITLE}
              {iconX && (
                <IconX
                  size={16}
                  cursor="pointer"
                  onClick={onClose}
                  color="var(--mantine-color-orange-6)"
                />
              )}
            </TextWrapper>
            <TextWrapper fz="sm" c="gray.9">
              {GA_ALERT_SUBTITLE}
            </TextWrapper>
          </Stack>
        </Group>
      </Card.Section>
    </Card>
  );
};

export default GAAlertMessageCard;
